import { BrowserRouter, Route, Routes } from "react-router";
import {
  NoInvoiceMoneyTransferScreen,
  NoInvoiceMoneyTransferScreenPath,
} from "./MoneyTransfer/NoInvoiceMoneyTransferScreen.tsx";
import {
  DisplayMoneyTransferInfoScreen,
  DisplayMoneyTransferInfoScreenPath,
} from "./MoneyTransfer/DisplayMoneyTransferInfoScreen.tsx";
import {
  InvoiceMoneyTransferScreen,
  InvoiceMoneyTransferScreenPath,
} from "./MoneyTransfer/InvoiceMoneyTransferScreen.tsx";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={NoInvoiceMoneyTransferScreenPath}
          element={<NoInvoiceMoneyTransferScreen />}
        />
        <Route
          path={InvoiceMoneyTransferScreenPath}
          element={<InvoiceMoneyTransferScreen />}
        />
        <Route
          path={DisplayMoneyTransferInfoScreenPath}
          element={<DisplayMoneyTransferInfoScreen />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
